import { render } from "./CuentasBancariasList.vue?vue&type=template&id=470ae852&scoped=true"
import script from "./CuentasBancariasList.vue?vue&type=script&lang=js"
export * from "./CuentasBancariasList.vue?vue&type=script&lang=js"

import "./CuentasBancariasList.vue?vue&type=style&index=0&id=470ae852&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470ae852"]])

export default __exports__